<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1000"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Create New Notification
        </v-toolbar-title>
      </v-toolbar>
      <v-stepper v-model="step">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1">Select Time Period</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 2" step="2">Configure Notification</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3">Target Notification</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card flat class="mb-12" height="450px">
              <v-card-text style="text-align: center;">
                <v-row>
                  <v-col>
                    <div>Start Date</div>
                    <v-date-picker color="green" v-model="startDate" :allowed-dates="allowedStartDates" @change="onStartDateChanged"></v-date-picker>
                  </v-col>
                  <v-col>
                    <div>End Date</div>
                    <v-date-picker color="red" v-model="endDate" :allowed-dates="allowedEndDates" showCurrent="false"></v-date-picker>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-spacer style="margin-top: 90px;"></v-spacer>
            <div>
              <span style="float: right;">
                <v-btn class="mr-5" color="primary" @click="step = 2">Next</v-btn>
                <v-btn color="secondary" @click="onCloseClick()">Cancel</v-btn>
              </span>
            </div>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-card flat class="mb-12" height="450px">
              <v-row>
                <v-col style="padding: 0 24px 0 24px;">
                  <div style="aligner-items: stretch; display: flex;">
                    <v-sheet tile elevation="5" class="pa-3" color="success">
                      <div style="text-align: center">
                        <div>Starts On</div>
                        <div><b>{{startDate}}</b></div>
                      </div>
                    </v-sheet>
                    <hr class="v-divider theme--light" style="align-self: center; margin: 0 12px;">
                    <!--
                    <v-sheet tile elevation="5" class="pa-3" color="white">
                      <div style="text-align: center">
                        <div><i>Target</i></div>
                        <div v-if="targetCity"><b>{{targetCity}}</b></div>
                        <div v-if="targetRegion"><b>{{targetRegion}}</b></div>
                        <div v-if="targetCountry"><b>{{targetCountry}}</b></div>
                      </div>
                    </v-sheet>
                    <hr class="v-divider theme--light" style="align-self: center; margin: 0 12px;">
                    -->
                    <v-sheet tile elevation="5" class="pa-3" color="error">
                      <div style="text-align: center">
                        <div>Ends On</div>
                        <div><b>{{endDate}}</b></div>
                      </div>
                    </v-sheet>
                  </div>
                </v-col>
              </v-row>
              <v-row class="mt-10">
                <v-col>
                  <v-text-field
                    v-model="name"
                    label="Notification Name"
                    outlined
                  >
                  </v-text-field>
                  <v-select
                    v-model="mimeType"
                    :items="mimeTypeSelection"
                    label="Content MIME Type"
                    outlined
                  >
                  </v-select>
                  <v-text-field
                    v-model="resourcePath"
                    label="Content Path"
                    outlined
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card>
            <v-spacer style="margin-top: 90px;"></v-spacer>
            <div>
              <v-btn class="mr-5" color="primary" @click="step = 1">Previous</v-btn>
              <span style="float: right;">
                <v-btn class="mr-5" color="primary" @click="step = 3">Next</v-btn>
                <v-btn color="secondary" @click="onCloseClick()">Cancel</v-btn>
              </span>
            </div>
          </v-stepper-content>
          <v-stepper-content step="3">
            <v-card flat class="mb-12" height="450px">
              <v-row>
                <v-col style="padding: 0 24px 0 24px;">
                    <div style="aligner-items: stretch; display: flex;">
                      <v-sheet tile elevation="5" class="pa-3" color="success">
                        <div style="text-align: center">
                          <div>Starts On</div>
                          <div><b>{{startDate}}</b></div>
                        </div>
                      </v-sheet>
                      <hr class="v-divider theme--light" style="align-self: center; margin: 0 12px;">
                      <!--
                      <v-sheet tile elevation="5" class="pa-3" color="white">
                        <div style="text-align: center">
                          <div><i>Target</i></div>
                          <div v-if="targetCity"><b>{{targetCity}}</b></div>
                          <div v-if="targetRegion"><b>{{targetRegion}}</b></div>
                          <div v-if="targetCountry"><b>{{targetCountry}}</b></div>
                        </div>
                      </v-sheet>
                      <hr class="v-divider theme--light" style="align-self: center; margin: 0 12px;">
                      -->
                      <v-sheet tile elevation="5" class="pa-3" color="error">
                        <div style="text-align: center">
                          <div>Ends On</div>
                          <div><b>{{endDate}}</b></div>
                        </div>
                      </v-sheet>
                    </div>
                </v-col>
              </v-row>
              <v-row class="mt-10">
                <v-col>
                  <v-row>
                    <v-col>
                      <v-select
                        label="Target Family"
                        v-model="targetFamily"
                        :items="familySelection"
                        outlined
                        @change="onTargetFamilyChanged"
                        >
                      </v-select>
                    </v-col>
                    <v-col>
                      <v-select
                        v-model="targetCountry"
                        :items="countrySelection"
                        label="Target Country"
                        outlined
                        @change="onTargetCountryChanged"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-select
                        v-model="targetRegion"
                        :items="regionSelection"
                        label="Target Region"
                        outlined
                        @change="onTargetRegionChanged"
                      >
                      </v-select>
                    </v-col>
                    <v-col>
                      <v-select
                        v-model="targetCity"
                        :items="citySelection"
                        label="Target City"
                        outlined
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
            <v-spacer style="margin-top: 90px;"></v-spacer>
            <div>
              <v-btn class="mr-5" color="primary" @click="step = 2">Previous</v-btn>
              <span style="float: right;">
                <v-btn class="mr-5" color="primary" :disabled="createDisabled" @click="onCreateClick">Create</v-btn>
                <v-btn color="secondary" @click="onCloseClick()">Cancel</v-btn>
              </span>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-dialog>
</template>

<script>
const moment = require('moment');

export default {
  props: {
    dialog: Boolean,
    startDate: String,
    endDate: String,
  },

  data() {
    return {

      mimeTypeSelection: ['image/png', 'image/jpeg', 'text/html'],

      familySelection: ['aligner', 'gtps', 'all'],
      countrySelection: [],
      regionSelection: [],
      citySelection: [],

      name: '',
      mimeType: '',
      resourcePath: '',
      targetType: 'geographic',
      targetFamily: '',
      targetCountry: '',
      targetRegion: '',
      targetCity: '',

      step: 1,
    };
  },

  computed: {
    createDisabled() {
      return (!this.name || !this.mimeType || !this.resourcePath || !this.targetType || !this.targetFamily || !this.targetCountry);
    },
  },

  mounted() {
    this.getCountries();
  },

  methods: {
    getCountries() {
      const options = {
        method: 'get',
        url: '/read/aligner_countries/v1',
      };

      this.axios(options)
        .then((res) => {
          this.countrySelection = res.data.map(cur => cur.countryName);
        })
        .catch((err) => {
          this.busy = false;
        });
    },

    allowedStartDates(val) {
      return moment(val).isSameOrAfter(new Date().toISOString().substr(0, 10));
    },

    allowedEndDates(val) {
      return moment(val).isSameOrAfter(this.startDate);
    },

    onStartDateChanged() {
      if (moment(this.startDate).isAfter(this.endDate)) {
        this.endDate = this.startDate;
      }
    },

    onTargetCountryChanged(val) {
      this.targetRegion = '';
      this.targetCity = '';

      const options = {
        method: 'get',
        url: `/read/aligner_regions/v1?countryName=${val}`,
      };

      this.axios(options)
        .then((res) => {
          this.regionSelection = res.data.map(cur => cur.region);
        })
        .catch((err) => {
          this.busy = false;
        });
    },

    onTargetRegionChanged(val) {
      this.targetCity = '';

      const options = {
        method: 'get',
        url: `/read/aligner_cities/v1?countryName=${this.targetCountry}&region=${val}`,
      };

      this.axios(options)
        .then((res) => {
          this.citySelection = res.data.map(cur => cur.city);
        })
        .catch((err) => {
          this.busy = false;
        });
    },

    reset() {
      this.step = 1;
      this.name = '';
      this.resourcePath = '';
      this.mimeType = '';
      this.targetType = 'geographic';
      this.targetFamily = '';
      this.targetCountry = '';
      this.targetRegion = '';
      this.targetCity = '';
    },

    onCloseClick() {
      this.$emit('close', null);
      this.reset();
    },

    onCreateClick() {
      this.$emit('close', {
        name: this.name,
        resourcePath: this.resourcePath,
        mimeType: this.mimeType,
        beginsOn: moment(this.startDate).startOf('day'),
        endsOn: moment(this.endDate).endOf('day'),
        targetType: this.targetType,
        target: {
          family: this.targetFamily,
          country: this.targetCountry,
          region: this.targetRegion ? this.targetRegion : null,
          city: this.targetCity ? this.targetCity : null,
        },
      });
      this.reset();
    },
  },
};
</script>
